import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import apiClient from "../api/apiClient";
import { saveHallOfFame, searchItemsAPI } from "../reduxData/user/userAction";
const HallOfFameManager = () => {
  const [slots, setSlots] = useState([
    { tempId: 1, itemId: null, item_name: "", photo: null, flavorText: "" },
    { tempId: 2, itemId: null, item_name: "", photo: null, flavorText: "" },
    { tempId: 3, itemId: null, item_name: "", photo: null, flavorText: "" },
  ]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [activeSlotIndex, setActiveSlotIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    fetchCurrentData();
  }, []);

  const fetchCurrentData = async () => {
    try {
      const res = await apiClient.get("/public/hall-of-fame");
      if (res.data && res.data.status) {
        const fetchedItems = res.data.data;
        
        const newSlots = [...slots];
        fetchedItems.forEach((item, index) => {
          if (index < 3) {
            newSlots[index] = {
              ...newSlots[index],
              itemId: item._id,
              item_name: item.item_name,
              photo: item.photo, 
              flavorText: item.flavorText || "",
            };
          }
        });
        setSlots(newSlots);
      }
    } catch (error) {
      console.error("Failed to load HOF", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchTerm.length >= 2) {
        setSearching(true);
        const results = await searchItemsAPI(searchTerm);
        setSearchResults(results);
        setSearching(false);
      } else {
        setSearchResults([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const handleSelectItem = (item) => {
    const newSlots = [...slots];
    const displayPhoto = item.photos && item.photos.length > 0 ? item.photos[0] : null;

    newSlots[activeSlotIndex] = {
      ...newSlots[activeSlotIndex],
      itemId: item._id,
      item_name: item.item_name,
      photo: displayPhoto,
      flavorText: "",
    };

    setSlots(newSlots);
    setActiveSlotIndex(null); 
    setSearchTerm("");
    setSearchResults([]);
  };

  const handleRemoveItem = (index) => {
    const newSlots = [...slots];
    newSlots[index] = { 
      tempId: newSlots[index].tempId, 
      itemId: null, 
      item_name: "", 
      photo: null, 
      flavorText: "" 
    };
    setSlots(newSlots);
  };

  const handleFlavorTextChange = (index, text) => {
    const newSlots = [...slots];
    newSlots[index].flavorText = text;
    setSlots(newSlots);
  };

  const handleSave = async () => {
    setSaving(true);
    const payload = slots
      .filter((slot) => slot.itemId !== null)
      .map((slot) => ({
        itemId: slot.itemId,
        flavorText: slot.flavorText,
      }));

    await saveHallOfFame(payload);
    setSaving(false);
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="card shadow mb-4">
      <div className="card-header py-3 d-flex justify-content-between align-items-center">
        <h6 className="m-0 font-weight-bold text-primary">Manage Hall of Fame</h6>
        <button 
          className="btn btn-primary" 
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>
      <div className="card-body">
        <div className="row">
          {slots.map((slot, index) => (
            <div className="col-md-4 mb-4" key={slot.tempId}>
              <div className="card h-100 border-left-primary">
                <div className="card-body">
                  <h5 className="card-title">Slot {index + 1}</h5>
                  
                  {slot.itemId ? (
                    <div className="text-center">
                      <div className="mb-3" style={{ height: "150px", overflow: "hidden", borderRadius: "8px", background: "#f8f9fa" }}>
                        {slot.photo ? (
                          <img 
                            src={slot.photo} 
                            alt="preview" 
                            style={{ width: "100%", height: "100%", objectFit: "contain" }} 
                          />
                        ) : (
                          <div className="d-flex align-items-center justify-content-center h-100 text-muted">No Image</div>
                        )}
                      </div>
                      
                      <h6 className="font-weight-bold text-truncate" title={slot.item_name}>
                        {slot.item_name}
                      </h6>
                      
                      <div className="form-group mt-3 text-left">
                        <label className="small text-muted">Flavor Text (Required)</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="e.g. Highest result for a Lugia GB promo in the market"
                          value={slot.flavorText}
                          onChange={(e) => handleFlavorTextChange(index, e.target.value)}
                        />
                      </div>

                      <button 
                        className="btn btn-danger btn-sm mt-2 w-100"
                        onClick={() => handleRemoveItem(index)}
                      >
                        Remove / Change
                      </button>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <p className="text-muted mb-3">Empty Slot</p>
                      <button 
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setActiveSlotIndex(index)}
                      >
                        <i className="fas fa-plus mr-1"></i> Select Auction
                      </button>
                    </div>
                  )}

                  {activeSlotIndex === index && (
                    <div className="mt-3 position-relative">
                      <div className="input-group input-group-sm">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search auctions by name..."
                          autoFocus
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <div className="input-group-append">
                          <button 
                            className="btn btn-outline-secondary" 
                            onClick={() => {
                              setActiveSlotIndex(null);
                              setSearchTerm("");
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>

                      {searchTerm.length >= 2 && (
                        <div className="position-absolute w-100 shadow bg-white rounded border" style={{ zIndex: 1000, maxHeight: "250px", overflowY: "auto", top: "100%" }}>
                          {searching ? (
                            <div className="p-2 text-center small text-muted">Searching...</div>
                          ) : searchResults.length > 0 ? (
                            <ul className="list-group list-group-flush">
                              {searchResults.map((item) => (
                                <li 
                                  key={item._id} 
                                  className="list-group-item list-group-item-action cursor-pointer p-2"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSelectItem(item)}
                                >
                                  <div className="d-flex align-items-center">
                                    <div style={{ width: "40px", height: "40px", flexShrink: 0, background: "#eee", marginRight: "10px" }}>
                                      {item.photos && item.photos[0] && (
                                        <img src={item.photos[0]} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                      )}
                                    </div>
                                    <div className="small text-truncate">
                                      {item.item_name}
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <div className="p-2 text-center small text-muted">No items found</div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HallOfFameManager;